import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { MedioPagoCalculadora } from '../models/medio-pago-calculadora.model';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class MediosPagoCalculadoraService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getMediosPago(page: number, itemsPerPage: number, sorts: SortConfiguration[], extraParams: any) {
        const url = '/calculadora/medios-de-pago';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts)
        };
        Object.assign(params, JSON.parse(JSON.stringify(extraParams)));
        return this.http.get<MedioPagoCalculadora[]>(url, { headers, observe: 'response', params });
    }

    getMedioPagoById(id: number) {
        return this.http.get<MedioPagoCalculadora>(`/calculadora/medios-de-pago/${id}`);
    }

    createMedioPago(medio: MedioPagoCalculadora) {
        return this.http.post<MedioPagoCalculadora>('/calculadora/medios-de-pago', medio);
    }

    updateMedioPago(medio: MedioPagoCalculadora) {
        return this.http.put<MedioPagoCalculadora>(`/calculadora/medios-de-pago/${medio.id}`, medio);
    }

    deleteMedioPago(id: number) {
        return this.http.delete<MedioPagoCalculadora>(`/calculadora/medios-de-pago/${id}`);
    }
}
